import { Component, OnInit, Input, EventEmitter, Output  } from '@angular/core';
import { FormGroup, FormArray, FormControl } from '@angular/forms';
import { exploitations } from 'src/app/shared/constants/exploitations';
import { objectives } from 'src/app/shared/constants/objectives';
import { Image } from 'src/app/shared/dtos/Image';
import { FarmService } from '../../farm.service';
import { LocationService } from '../../location.service';
import { Province } from 'src/app/shared/dtos/Province';
import { TownHall } from 'src/app/shared/dtos/TownHall';
import { MapService } from '../../map.service';
import { District } from 'src/app/shared/dtos/District';
import { Municipality } from 'src/app/shared/dtos/Municipality';
import { ActivatedRoute } from '@angular/router';
import { NgxFileDropEntry, FileSystemFileEntry, FileSystemDirectoryEntry } from 'ngx-file-drop';
import { ObjectFile } from 'src/app/util/interfaces/common/ObjectFile';
import { UtilsService } from 'src/app/util/services/utils.service';

@Component({
  selector: 'app-step1',
  templateUrl: './step1.component.html',
  styleUrls: ['./step1.component.css']
})
export class Step1Component implements OnInit {

  @Input() formParent: FormGroup;
  @Input() ubication: any;
  @Output()uploadImage = new EventEmitter<Image>();

  data_exploitation = exploitations;
  data_objectives = objectives;
  filesAmount = 0;
  municipalityDisable = true;

  provinces: Province [];
  townHalls: TownHall [];

  districts: District [];
  municipalities: Municipality [];
  countries: any[] = [];

  @Output()
  location = new EventEmitter<TownHall>();
  isEdit: boolean;
  public files: NgxFileDropEntry [] = [];
  imagesAccepted: ObjectFile[] = [];

  constructor(
    private locationService: LocationService,
    private farmService: FarmService,
    private mapService: MapService,
    private activatedRoute: ActivatedRoute,
    private utilService: UtilsService) { }

  ngOnInit(): void {
    const id = this.activatedRoute.snapshot.params['id'];
    this.getCountries();
    this.isEdit = (id != undefined);
    if (!this.isEdit){
      this.getProvinces();
      this.getDistricts();
      this.setDefaultValuesCheckbox('objectives');
    }
    if (this.formParent.get('province').value != undefined){
      this.getProvinces();
    }
    if (this.formParent.get('district').value != undefined){
      this.getDistricts();
    }
  }

  checkObjectives(objective: any){
    const objectives = (this.formParent.get('objectives') as FormArray).getRawValue();
    return objectives.includes(objective.type) || !!objectives.find(x => x.type === objective.type);
  }

  checkExploitations(exploitation: any){
    const exploitations = (this.formParent.get('exploitations') as FormArray).getRawValue();
    return exploitations.includes(exploitation.type);
  }

  setDefaultValuesCheckbox(nameCheckbox: string) {
    const checkbox = <FormArray>this.formParent.get(nameCheckbox) as FormArray;
    const value = this.data_objectives.find(x => x.id === 3 );
    checkbox.push(new FormControl(value));
  }

  onChange(event, nameCheckbox, value) {
    const checkbox = <FormArray>this.formParent.get(nameCheckbox) as FormArray;
    if (event.checked) {
      checkbox.push(new FormControl(value));
    } else {
     const i = checkbox.controls.findIndex(x => x.value === (x.value.id ? value : value.type));
     checkbox.removeAt(i);
    }
  }

  onChangeDistrict(event) {
    const idDistrict = event.value;
    this.ubication.district = this.districts.find(x => x.idDistrict === idDistrict);
    this.locationService.getMunicipalitiesByIdDistricts(idDistrict)
      .subscribe(municipalities => {
        this.municipalities = municipalities;
      });
    this.municipalityDisable = false;
  }

  onSelectedMunicipality(municipality: any) {
    this.mapService.setLocationPortugalFilter(municipality);
    this.mapService.setLocationPortugalStep(municipality);
    this.formParent.get('municipality').setValue(municipality);
    this.ubication.municipality = this.municipalities.find(x => x.idMunicipality === municipality);
    // this.mapService.setLocationFilter(townHall);
  }

  onChangeProvince(event) {
    const idProvince = event.value;
    this.ubication.province = this.provinces.find(x => x.idProvince === idProvince);
    this.locationService.getTownHallsByIdProvince(idProvince)
      .subscribe(townHalls => {
        this.townHalls = townHalls;
      });
  }

  selectedTownHall(townHall: any) {
    this.mapService.setLocationFilter(townHall);
    this.mapService.setLocationStep(townHall);
    this.ubication.townHall = this.townHalls.find(x => x.idTownHall === townHall);
 }

  getProvinces() {
    let idProvince: number;
    let idTownHall: number;
    if (this.isEdit){
      idProvince = this.formParent.get("province").value;
      idTownHall = this.formParent.get("townHall").value;
    }
    this.locationService.getProvincesSpain()
      .subscribe( provinces => { 
        this.provinces = provinces;
        if (this.isEdit){
          this.ubication.province = provinces.find(x => x.idProvince === idProvince);
          this.locationService.getTownHallsByIdProvince(idProvince)
          .subscribe(townHalls => {
            this.townHalls = townHalls;
            this.ubication.townHall = townHalls.find(x => x.idTownHall === idTownHall);
          });
        }
        else {
          this.formParent.get('province').setValue(provinces[0].idProvince);
          this.ubication.province = provinces.find(x => x.idProvince === provinces[0].idProvince);
          this.locationService.getTownHallsByIdProvince(provinces[0].idProvince)
          .subscribe(townHalls => {
            this.townHalls = townHalls;
            this.formParent.get('townHall').setValue(townHalls[0].idTownHall);
            this.ubication.townHall = townHalls.find(x => x.idTownHall === townHalls[0].idTownHall);
          });
        }
      });
  }

  getDistricts() {
    let idDistrict: number;
    let idMunicipality: number;
    if (this.isEdit){
      idDistrict = this.formParent.get("district").value;
      idMunicipality = this.formParent.get("municipality").value;
    }
    this.locationService.getDistrictsPortugal()
      .subscribe(districts => {
        this.districts = districts;
        if (this.isEdit){
          this.ubication.district = districts.find(x => x.idDistrict === idDistrict);
          this.locationService.getMunicipalitiesByIdDistricts(idDistrict)
          .subscribe(municipalities => {
            this.municipalities = municipalities;
            this.ubication.municipality = municipalities.find(x => x.idMunicipality === idMunicipality);
          });
        }
        else {
          this.formParent.get('district').setValue(districts[0].idDistrict);
          this.ubication.district = districts.find(x => x.idDistrict === districts[0].idDistrict);
          this.locationService.getMunicipalitiesByIdDistricts(districts[0].idDistrict)
          .subscribe(municipalities => {
            this.municipalities = municipalities;
            this.formParent.get('municipality').setValue(municipalities[0].idMunicipality);
            this.ubication.municipality = municipalities.find(x => x.idMunicipality === municipalities[0].idMunicipality);
          });
        }
      });
  }

  getCountries(){
    this.countries = this.farmService.getCountries();
  }

  getCountryDefault(){
    return this.getCountries()[0].id;
  }

  compareFunction(o1: any, o2: any){
    return (o1.id === o2.id && o1.cod === o2.cod && o1.country === o2.country);
  }

  droppedImages(files: NgxFileDropEntry[]) {
    this.files = files;
    files.map((droppedFile) => {
      // Is it a file and a image?
      if (droppedFile.fileEntry.isFile && this.utilService.isImage(droppedFile.fileEntry.name)) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        const reader = new FileReader();
        fileEntry.file((file: File) => {
          reader.readAsDataURL(file);
          reader.onloadend = (evt: any) => {
            const image: ObjectFile = {
              format: file.name.split('.')[1],
              file: evt.target.result,
              name: file.name
            };
            this.imagesAccepted.push(image);
            this.formParent.get('listObjectFiles').setValue(this.imagesAccepted);
          };
          // reader.readAsText(file);
          // Here you can access the real file
        });
      } else {
        // It was a directory (empty directories are added, otherwise only files)
        const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
        alert('El archivo no tiene el formato correcto');
        console.log(droppedFile.relativePath, fileEntry);
      }
    });
  }

  fileOver(event){
    console.log(event);
  }

  fileLeave(event){
    console.log(event);
  }

  onDeleteImage(index: number){
    const arrayFiltered = this.imagesAccepted.filter((file, indexFile) => indexFile !== index);
    this.imagesAccepted = arrayFiltered;
    this.formParent.get('listObjectFiles').setValue(arrayFiltered);
  }

}
